import React from 'react';
import { Container } from 'react-bootstrap';
import useSeo from '../services/useSeo';

function PrivacyPolicy() {
  useSeo({
    title: '隱私權政策 | 琴語鋼琴網',
    description: '琴語鋼琴網的隱私權政策，說明我們如何蒐集、使用及保護您的個人資料。',
    canonicalPath: '/privacy',
  });
  return (
    <Container className="my-5">
      <h1>隱私權政策</h1>
      <div className="mt-4">
        <h2>1. 資料蒐集</h2>
        <p>
          我們僅收集您在使用本服務時主動提供的個人資料，包括但不限於：姓名、電子郵件地址、聯絡電話等。這些資料將用於提供您所需的服務及改善使用者體驗。
        </p>
        <br/>
        <p>本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。 </p>
        <p>於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的 IP 位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</p>
        <p>為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</p>
        <p>您可以隨時向我們提出請求，以更正或刪除您的帳戶或本網站所蒐集的個人資料等隱私資訊。聯繫方式請見最下方聯繫管道。</p>

        <h2>2. 資料使用</h2>
        <p>
          您的個人資料將用於以下用途：
          <ul>
            <li>處理您的訂單及付款</li>
            <li>提供客戶服務</li>
            <li>發送服務相關通知</li>
            <li>改善我們的服務品質</li>
          </ul>
        </p>

        <h2>3. 資料保護</h2>
        <p>
          我們採用適當的技術及組織措施來保護您的個人資料，防止未經授權的存取、使用或洩漏。
        </p>

        <h2>4. 第三方分享</h2>
        <p>
        本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。
        </p>
        <p>
        前項但書之情形包括不限於：
        </p>
        <ul>
          <li>經由您書面同意。</li>
          <li>法律明文規定。</li>
          <li>為免除您生命、身體、自由或財產上之危險。</li>
          <li>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</li>
          <li>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
          <li>有利於您的權益。</li>
          <li>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</li>
        </ul>

        <h2>5. Cookie 使用</h2>
        <p>
          我們使用 Cookie 來改善您的瀏覽體驗。您可以透過瀏覽器設定來控制或刪除 Cookie。
        </p>

        <h2>6. 隱私權政策更新</h2>
        <p>
          我們保留隨時修改本隱私權政策的權利。政策更新時，我們會在網站上公告修改內容。
        </p>

        <h2>7. 聯絡我們</h2>
        <p>
          如果您對我們的隱私權政策有任何疑問，請聯絡我們的客服團隊。 
        </p>
        <p>
          聯絡方式：
        </p>
        <p>
          pianolang.service@gmail.com
        </p>
      </div>
    </Container>
  );
}

export default PrivacyPolicy;
